import { typeUtils } from '@festina-life/core'
import {
  FormikDateRangePicker,
  FormikFilterFormButtons,
  FormikForm,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { TradeCycleFilterFormValues } from './tradeCycleFilterUtils'

const validateKey = typeUtils.createValidator<TradeCycleFilterFormValues>()

type Props = {
  initialValues: TradeCycleFilterFormValues
  onSearch: (values: TradeCycleFilterFormValues) => void
}

export const TradeCycleFiltersForm = ({ initialValues, onSearch }: Props) => {
  const translate = useTranslate()

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSearch}
      shouldSubmitOnMount
      layout="horizontal"
    >
      <FormikDateRangePicker
        fromDateName={validateKey('fromDate')}
        toDateName={validateKey('toDate')}
        label={translate('dateRangePicker.label')}
      />
      <FormikFilterFormButtons />
    </FormikForm>
  )
}
